import { Pipe, PipeTransform } from "@angular/core";
import { Evaluation, Sample } from "@core/data";
import { Snackbar } from "@core/material";

@Pipe({
    name: 'describeCode',
})
export class DescribeCodePipe implements PipeTransform {

    constructor () {}

    transform(code: string, size: number = null) {

        const pattern = /^[A-Z]{2}(\-[A-Z 0-9]{4})+$/gm;

        if (!code.match(pattern)) return 'Invalid Code';

        if (!size || size < 1) return `${code} `;

        let definition = code.slice(0, 3);
        let body = code.slice(3);

        return `${definition}${body.slice(0,size)} `;
    }
}